<div class="form-group">
  <label *ngIf="label">{{ label }}</label>
  <input
    #inputElement
    [type]="inputType"
    [(ngModel)]="value"
    [id]="id"
    [name]="name"
    (input)="validateAgGird()"
    [placeholder]="placeholder"
  />
</div>
